import { AnyAction } from "redux";
import { REHYDRATE } from "redux-persist";
import { cleanSuccessOportunitiesFetching, getCitroenToken } from "../../actions/citroen";

export default function userMiddleware(store: any) {
    return (next: any) => async (action: AnyAction) => {
        const result = next(action);
        if (action.type === REHYDRATE && store.getState().citroen?.token?.expirationTime) {
            getCitroenToken("rehydrate")(store.dispatch, store.getState);
        }
        if (action.type === REHYDRATE && store.getState().citroen?.fetchingOportunities === "success") {
            cleanSuccessOportunitiesFetching()(store.dispatch)
        }
        return result;
    }
};